// extracted by mini-css-extract-plugin
module.exports = {"main":"dropcap-module--main--iuc11"};